import { Component, OnInit, ViewChild, computed, inject } from '@angular/core';
import { SigningAuthenticatorSetupComponent } from '@app/components/signing-manager/signing-authenticator-setup/signing-authenticator-setup.component';
import { SigningOtpDialogComponent } from '@app/components/signing-manager/signing-otp-dialog/signing-otp-dialog.component';
import { SigningSessionStateService } from '@app/services/signing-session-state.service';

@Component({
  selector: 'app-signing-dashboard',
  templateUrl: './signing-dashboard.component.html',
  styleUrl: './signing-dashboard.component.scss',
})
export class SigningDashboardComponent implements OnInit {
  readonly state = inject(SigningSessionStateService);

  @ViewChild(SigningOtpDialogComponent) otpDialog!: SigningOtpDialogComponent;
  @ViewChild(SigningAuthenticatorSetupComponent) setupDialog!: SigningAuthenticatorSetupComponent;

  readonly needsSetup = computed(() => this.state.authenticatorConfigured() === false);

  readonly sessionButton = computed(() => {
    if (this.state.isActive()) return { key: 'Signing_Dashboard_SessionActive', fallback: 'Session Active', icon: 'pi pi-lock' };
    if (this.state.isPendingVerification())
      return { key: 'Signing_Dashboard_ContinueVerification', fallback: 'Continue Verification', icon: 'pi pi-key' };
    if (this.needsSetup()) return { key: 'Signing_Dashboard_SetupAuthenticator', fallback: 'Set Up Authenticator', icon: 'pi pi-mobile' };
    return { key: 'Signing_Dashboard_NewSession', fallback: 'New Session', icon: 'pi pi-lock-open' };
  });

  readonly buttonDisabled = computed(() => this.state.isActive() || !this.state.loaded() || this.state.authenticatorConfigured() === null);

  ngOnInit(): void {
    this.state.ensureLoaded();
  }

  onPrimaryAction(): void {
    if (this.state.isActive()) return;
    if (this.needsSetup() && !this.state.isPendingVerification()) {
      this.setupDialog.open();
      return;
    }
    this.startSession();
  }

  startSession(): void {
    if (this.state.isActive()) return;
    this.otpDialog.start();
  }
}
